import React from 'react';
import Icon from 'components/AppIcon';
import { useAuth } from '../../contexts/AuthContext';
import { ALL_TIERS, PLATFORM_OWNER_LABEL } from '../../utils/adminOverride';

/**
 * PlatformOwnerBadge
 * Shown only when the platform owner (365ddevotional@gmail.com) is logged in.
 * Allows simulating different subscription tiers for UI testing.
 */
export default function PlatformOwnerBadge({ compact = false }) {
  const { isPlatformOwner, simulatedTier, setSimulatedTier } = useAuth();

  if (!isPlatformOwner) return null;

  if (compact) {
    return (
      <div
        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold"
        style={{
          background: 'linear-gradient(135deg, rgba(16,185,129,0.2), rgba(99,102,241,0.2))',
          border: '1px solid rgba(16,185,129,0.5)',
          color: '#10B981',
          fontFamily: 'var(--font-caption)',
        }}
      >
        <Icon name="ShieldCheck" size={11} color="#10B981" />
        {PLATFORM_OWNER_LABEL}
      </div>
    );
  }

  return (
    <div
      className="flex flex-wrap items-center gap-3 px-4 py-3 rounded-2xl"
      style={{
        background: 'linear-gradient(135deg, rgba(16,185,129,0.08), rgba(99,102,241,0.08))',
        border: '1px solid rgba(16,185,129,0.4)',
      }}
    >
      {/* Badge label */}
      <div className="flex items-center gap-2">
        <div
          className="w-7 h-7 rounded-lg flex items-center justify-center"
          style={{ background: 'rgba(16,185,129,0.2)' }}
        >
          <Icon name="ShieldCheck" size={15} color="#10B981" />
        </div>
        <div>
          <p
            className="text-xs font-bold"
            style={{ color: '#10B981', fontFamily: 'var(--font-heading)' }}
          >
            {PLATFORM_OWNER_LABEL}
          </p>
          <p
            className="text-xs"
            style={{ color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-caption)' }}
          >
            Full enterprise access &middot; No billing required
          </p>
        </div>
      </div>
      {/* Tier simulator */}
      <div className="flex items-center gap-2 ml-auto">
        <span
          className="text-xs"
          style={{ color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-caption)' }}
        >
          Simulate plan:
        </span>
        <div className="flex gap-1">
          {ALL_TIERS?.map((tier) => (
            <button
              key={tier}
              onClick={() => setSimulatedTier(tier)}
              className="px-2 py-0.5 rounded-lg text-xs font-semibold capitalize transition-all hover:opacity-90"
              style={{
                background:
                  (simulatedTier || 'enterprise') === tier
                    ? TIER_COLORS?.[tier]
                    : 'var(--color-muted)',
                color:
                  (simulatedTier || 'enterprise') === tier
                    ? 'white' : 'var(--color-muted-foreground)',
                fontFamily: 'var(--font-caption)',
              }}
            >
              {tier}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

const TIER_COLORS = {
  free: '#6B7280',
  pro: '#6366F1',
  studio: '#F59E0B',
  enterprise: '#10B981',
};
